<template>
    <div>
        <b-modal
            centered
            no-close-on-backdrop
            no-close-on-esc
            ref="modal-checkbill"
            @hidden="closeCheckbill"
            v-model="checkBill.show"
            hide-footer
          >
            <template slot="modal-title">
              <div slot="header" class="bg-white border-0">
                <div class="row align-items-center">
                  <div class="col-12">
                    <h3 class="mb-0">ข้อมูลการรับเงิน
                        <span v-if="this.$THEME.name == 'shippop'" @click="goToLinkManual()">
                            <i class="fas fa-info-circle fa-xs text-primary m-1" style="cursor: pointer;" 
                                v-b-tooltip title="คู่มือวิธีการใช้ส่วนลดท้ายบิล">
                            </i>
                        </span>
                    </h3>
                  </div>
                </div>
              </div>
            </template>
            <card shadow type="secondary" class="m--4">
              <template>
                <form @submit.prevent>
                    <div class>
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="group-result">
                                    <div class="price">
                                        <h6>ยอดรวมทั้งหมด</h6>
                                        <h1>
                                            <template v-if="useDiscount"> 
                                                <span class="text-muted number-discount px-2">{{totalPriceOrder | numFormat('0,0.00')}}</span>
                                                <span>{{totalBalance | numFormat('0,0.00')}} </span>
                                            </template>
                                            <template v-else> 
                                                <span>{{totalPriceOrder | numFormat('0,0.00')}} </span>
                                            </template>
                                            <small>บาท</small>
                                        </h1>
                                    </div>
                                </div>
                                <hr class="my-4" />
                            </div>
                            <div class="col-lg-12">
                                <div class="row">
                                    <div class="col-lg-5">
                                        <div class="switch-pos">
                                        <div class="d-flex align-items-center">
                                            <b-form-checkbox switch size="lg" v-model="useDiscount" @change="resetDiscount"></b-form-checkbox>
                                            <span>ส่วนลดท้ายบิล</span> 
                                        </div>
                                    </div>
                                    </div>
                                    <div class="col-lg-7">
                                        <b-form-radio-group class="custom-radio-discount" v-if="useDiscount" v-model="typeDiscount" @input="calculatePayment">
                                            <div class="row">
                                                <div class="col-lg-6 px-0" v-for="type in dataTypeDiscount" :key="type.key">
                                                    <b-form-radio :value="type.key">{{type.title}}</b-form-radio>
                                                </div>
                                            </div>
                                           
                                        </b-form-radio-group>
                                    </div>
                                    <div class="col-lg-12 text-right text-muted text-xs" v-if="useDiscount">{{getDiscountTooltip(typeDiscount)}}</div>
                                </div>
                                <div class="price pt-2" v-if="useDiscount">
                                    <h6>ส่วนลด</h6>
                                    
                                    <b-form-input
                                        type="number" 
                                        min="0.00"
                                        placeholder="0"
                                        class="input-discount hide-arrow"
                                        step=".01"
                                        v-model="numDiscount"
                                        :onkeypress="checkMaxDiscount"
                                        @change="checkMaxDiscount"
                                        @keyup="calculatePayment"
                                        :onkeydown="'return event.keyCode !== 69 && event.keyCode !== 189 && event.keyCode !== 187'"
                                    >
                                    </b-form-input>
                                    <span>{{getUnit}}</span>
                                </div>
                                <hr class="my-4" />
                            </div>
                            <div class="col-lg-12">
                                <div class="price">
                                    <h6>รับเงิน</h6>
                                    <base-input
                                        formClasses="mb-0"
                                        alternative
                                        typeInput="number"
                                        min="0.00"
                                        v-on:keyup="calculatePayment"
                                        placeholder="0"
                                        input-classes="form-control-alternative hide-arrow"
                                        v-model="checkBill.receiveMoney"
                                        size="lg"
                                        :onkeydown="'return event.keyCode !== 69 && event.keyCode !== 189 && event.keyCode !== 187'"
                                    />
                                </div>
                                <hr class="my-4" />
                            </div>
                            <div v-if="filterCheckDropoffLine" class="col-lg-12">
                                <div class="price d-flex justify-content-between">
                                    <div class="">
                                        <p>เลือกวิธีการชำระเงิน<span class="text-danger"> *</span></p>
                                    </div>
                                    <div class="text-primary cursor-pointer">
                                        <p v-b-tooltip.hover.html="tooltipLine" v-bind:style="{textAlign: 'left'}"><span><i class="far fa-question-circle"></i></span> ชำระผ่าน LINE ดีอย่างไร?</p>
                                    </div>
                                </div>
                                <div class="price radio-custom-payment">
                                    <div class="d-flex align-items-center">
                                      <div class="btn-group" data-toggle="buttons">
                                        <label class="btn size-button cursor-pointer"
                                        :class="typeMoneyCheckBill === 'checkOutShop' ? 'active-button' : ''"
                                        @click="emitTypeMoneyCheckBill('checkOutShop')"
                                        >
                                          <div class="">
                                            <div class="width-image-button">
                                                <img src="../../../../assets/images/line/cashpayment.png" />
                                            </div>
                                            <div class="mt-1">
                                                จ่ายเงินสดชำระหน้าร้าน
                                            </div>
                                          </div>
                                        </label>
                                        <label v-if="isHasBookBank" class="btn size-button cursor-pointer"
                                        :class="typeMoneyCheckBill === 'checkOutLINE' ? 'active-button' : ''"
                                        @click="emitTypeMoneyCheckBill('checkOutLINE')"
                                        >
                                          <div class="m-auto">
                                            <div class="">
                                                <div class="width-image-button">
                                                    <img src="../../../../assets/images/line/wallet.png" />
                                                </div>
                                                <div class="mt-1">
                                                    ชำระเงินผ่าน LINE
                                                </div>
                                            </div>
                                          </div>
                                        </label>
                                        <label v-else class="btn size-button cursor-pointer"
                                        @click="pushSetAddBookBank"
                                        >
                                          <div class="m-auto">
                                            <div class="">
                                                <div class="width-image-button">
                                                    <div class="circle-plus-blackground">
                                                        <img class="w-50" src="../../../../assets/icon/addplus.png" />
                                                    </div>
                                                </div>
                                                <div class="mt-1">
                                                    เพิ่มบัญชี(รับเงินผ่าน LINE)
                                                </div>
                                            </div>
                                          </div>
                                        </label>
                                      </div>

                                    </div>
                                </div>
                                <hr class="my-4" />
                            </div>
                            <div class="col-lg-12">
                                <div class="group-result">
                                    <div class="price">
                                        <h6>เงินทอน</h6>
                                        <h1>
                                            {{checkBill.changeMoney | numFormat('0,0.00')}}
                                            <small>บาท</small>
                                        </h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mt-4 w-100 text-right">
                        <b-button variant="secondary" @click="closeCheckbill">ยกเลิก</b-button>
                        <b-button
                            type="submit"
                            variant="success"
                            :disabled="!canConfirm"
                            @click="$emit('confirmCreateOrder')"
                        >ยืนยัน
                        </b-button>
                    </div>
                </form>
              </template>
            </card>
        </b-modal>
    </div>
</template>

<script>

const TYPE_BAHT = 'BAHT'
const TYPE_PERCENT = 'PERCENT'
const TYPE_BAHT_SHIP = 'BATH_SHIP'
const TYPE_PERCENT_SHIP = 'PERCENT_SHIP'

export default {
    name:'ModalCheckBill',
    props:{
        checkBill: Object,
        totalPriceOrder: Number,
        totalCourierPrice: Number,
        filterCheckDropoffLine: [Function, Boolean],
        isHasBookBank: Boolean,
        typeMoneyCheckBill: String
    },
    data(){
        return{
            selectedOption: '',
            useDiscount: false,
            numDiscount: '',
            typeDiscount: TYPE_BAHT,
            dataTypeDiscount:[
                { key: TYPE_BAHT , title: 'บาท', tooltip: 'ส่วนลดทั้งใบเสร็จคิดเป็นบาท'  , unit: 'บาท'},
                { key: TYPE_PERCENT , title: '%', tooltip: 'ส่วนลดทั้งใบเสร็จคิดเป็น %' , unit: '%'},
                { key: TYPE_BAHT_SHIP , title: 'ค่าขนส่ง (บาท)' , tooltip: 'ลดเฉพาะค่าขนส่งไม่รวมสินค้าและค่าบริการพื้นที่ห่างไกล' , unit: 'บาท'},
                { key: TYPE_PERCENT_SHIP , title: 'ค่าขนส่ง (%)' , tooltip: 'ลดเฉพาะค่าขนส่งไม่รวมสินค้าและค่าบริการพื้นที่ห่างไกล' , unit: '%'}
            ]
        }
    },
    methods:{
        isHasAccept() {
            if(this.filterCheckDropoffLine) {
                if(this.typeMoneyCheckBill === '') {
                    return false;
                }
                return true
            }
        },
        pushSetAddBookBank() {
            this.$router.push({path: '/branceedit/'})
        },
        emitTypeMoneyCheckBill(key) {
            return this.$emit("setTypeMoneyCheckBill", key);
        },
        tooltipLine() {
            return '<div style="text-align: left;"><strong style="font-size: 0.8rem;">การเรียกเก็บเงิน</strong><br><span style="font-size: 0.75rem;">ระบบจะทำการเรียกเก็บเงินผ่าน LINE ให้ลูกค้าอัตโนมัติ</span><br><br><strong style="font-size: 0.8rem;">ส่งใบเสร็จและหมายเลขติดตามพัสดุ</strong><br><span style="font-size: 0.75rem;">ระบบจะทำการส่งใบเสร็จรับเงินและหมายเลขติดตามพัสดุผ่าน LINE ให้ลูกค้าอัตโนมัติ</span></div>';
        },
        getDiscountTooltip(type) {
            let tooltip = ''
            this.dataTypeDiscount.forEach(discount => {
                if (type == discount.key) {
                    tooltip = discount.tooltip
                }
            });
            return tooltip
        },
        closeCheckbill() {
            this.checkBill.receiveMoney = "";
            this.checkBill.changeMoney = 0;
            this.checkBill.show = false;
            console.log('close check bill')
            // this.$emit('recheckCutOrderDraft', false)
        },
        calculatePayment() {
            this.totalPriceOrder = Number(parseFloat(this.totalPriceOrder).toFixed(2));
            this.checkBill.receiveMoney = parseFloat(this.checkBill.receiveMoney)
            
            if(this.useDiscount && this.totalBalance <= this.checkBill.receiveMoney){ 
                this.checkBill.changeMoney = this.checkBill.receiveMoney - this.totalBalance;
            }else if( !this.useDiscount && this.totalPriceOrder <= this.checkBill.receiveMoney) {
                this.checkBill.changeMoney = this.checkBill.receiveMoney - this.totalPriceOrder;
            } else {
                this.checkBill.changeMoney = 0;
            }

        },
        changeSelectType(){
            this.numDiscount = ''
        },
        resetDiscount(){
            this.typeDiscount = TYPE_BAHT
            this.checkBill.receiveMoney = '';
            this.checkBill.changeMoney = 0
            this.changeSelectType()
        },
        goToLinkManual(){
            window.open(`https://docs.google.com/document/d/1jKw23wtwB-ZUVC84eUqTL8iPe1ZUEQk-xPeS0j3ggmQ/edit?usp=sharing`, '_blank')
        },
        checkMaxDiscount() {
            if(this.typeDiscount == TYPE_BAHT && this.numDiscount > this.totalPriceOrder){
                this.changeSelectType()
            } else if(this.typeDiscount == TYPE_BAHT_SHIP && this.numDiscount > this.totalCourierPrice){
                this.changeSelectType()
            }else if ( [TYPE_PERCENT, TYPE_PERCENT_SHIP].includes(this.typeDiscount) && this.numDiscount > 100 ){
                this.changeSelectType()
            }
        }
    },
    computed: {
        canConfirm(){
            const receive = parseFloat(this.checkBill.receiveMoney)
            const threshold = this.useDiscount
                ? parseFloat(this.totalBalance)
                : parseFloat(this.totalPriceOrder)
            if (isNaN(receive) || isNaN(threshold)) return false
            return receive >= threshold
        },
        totalBalance(){
            let balance = ''
            if(this.typeDiscount == TYPE_BAHT || this.typeDiscount == TYPE_BAHT_SHIP){
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.checkBill.discountAmount = this.numDiscount;
                balance = this.totalPriceOrder - this.numDiscount;
            } else if(this.typeDiscount == TYPE_PERCENT_SHIP){
                let discount = this.numDiscount/ 100;
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.checkBill.discountAmount = (this.totalCourierPrice * discount).toFixed(2);
                balance = Number((this.totalPriceOrder - (this.totalCourierPrice * discount) ).toFixed(2));
            }else{
                let discount = this.numDiscount/ 100;
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.checkBill.discountAmount = (this.totalPriceOrder * discount).toFixed(2);
                balance = Number((this.totalPriceOrder - (this.totalPriceOrder * discount) ).toFixed(2));
            }
            return balance;
        },
        getUnit(){
            return (this.dataTypeDiscount.find(type => type.key === this.typeDiscount)).unit
        }
    }
}
</script>
<style scoped>
    h1, h2, h3, h4, h5, h6, div {
      color: #000;
    }
    .input-discount{
        max-width: 40%; 
        margin-left: 11rem;
        text-indent:10px;
    }
</style>

<style lang="scss" scoped>

.radio-custom-payment {
    .radio-button {
      visibility: hidden;
    }
    .width-image-button {
        width:50%;
        margin: auto;
        img {
            width: 100%;
        }
    }
    .active-button {
        background: #FFFFFF;
        border: 1px solid #11CDEF;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.15);
    }
    .size-button {
    //   border: 1px solid black;
      border-radius: 0;
      width: 150px;
      height: 150px;
      margin-right: 1rem;
      display: flex;
      justify-content: center;
      align-items: center;
      box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.15);
      border-radius: 7px 7px 7px 7px !important;
    }
    .size-button:hover {
        background: #FFFFFF;
        border: 1px solid #11CDEF;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.15);
    }
}
</style>